import { RouteRecordRaw } from 'vue-router'

/**
 * 模块路由配置s
 *
 * meta 元数据解析:
 *   title        页面标题
 *   keepAlive    是否缓存页面 默认不缓存
 *   rank         缓存页面的权重 默认 0.1
 *   authCode     权限码
 */
const routes: Array<RouteRecordRaw> = [
  {
    path: 'home',
    name: 'HomeView',
    component: () => import('@/views/home.vue'),
    meta: {
      title: '首页'
    }
  },
  {
    path: 'person-center',
    name: 'PersonCenter',
    component: () => import('@/views/person-center/person-center.vue'),
    meta: {
      title: '个人中心'
    }
  },
  {
    path: 'user-list',
    name: 'UserList',
    component: () => import('@/views/system/user/user-list.vue'),
    meta: {
      title: '用户管理',
      authCode: 'user-view'
    }
  },
  {
    path: 'menu-list',
    name: 'MenuList',
    component: () => import('@/views/system/menu/menu-list.vue'),
    meta: {
      title: '菜单管理',
      authCode: 'menu-view'
    }
  },
  {
    path: 'role-list',
    name: 'RoleList',
    component: () => import('@/views/system/role/role-list.vue'),
    meta: {
      title: '角色管理',
      authCode: 'role-view'
    }
  },
  {
    path: 'department-list',
    name: 'DepartmentList',
    component: () => import('@/views/system/department/department-list.vue'),
    meta: {
      title: '部门管理',
      authCode: 'department-view'
    }
  },
  {
    path: 'auth-code',
    name: 'AuthCode',
    component: () => import('@/views/system/auth-code/auth-code.vue'),
    meta: {
      title: '权限对照',
      authCode: 'auth-view'
    }
  },
  {
    path: 'ldap',
    name: 'LDAPConfig',
    component: () => import('@/views/system/ldap/ldap-config.vue'),
    meta: {
      title: 'LDAP 配置',
      authCode: 'ldap-view'
    }
  },
  {
    path: 'user-action',
    name: 'UserAction',
    component: () => import('@/views/system/user-action/user-action.vue'),
    meta: {
      title: '用户行为',
      authCode: 'user-action-view'
    }
  },
  {
    path: 'tapd-time',
    name: 'TapdTime',
    component: () => import('@/views/kanban/tapd/tapd.vue'),
    meta: {
      title: 'TAPD周报看板',
      authCode: 'kanban-tapd-time',
      keepAlive: true
    }
  },
  {
    path: 'hds-week-report',
    name: 'HdsWeekReport',
    component: () => import('@/views/kanban/hds-week-report/hds-week-report.vue'),
    meta: {
      title: 'HDS周报看板',
      authCode: '',
      keepAlive: true
    }
  },
  {
    path: 'casarst-deploy',
    name: 'CasarstDeploy',
    component: () => import('@/views/deploy/casarst/casarst.vue'),
    meta: {
      title: '卡萨帝小程序发版',
      authCode: 'deploy-casarst-mini',
      keepAlive: true
    }
  },
  {
    path: 'devops',
    name: 'Devops',
    component: () => import('@/views/deploy/devops/devops.vue'),
    children: [
      {
        path: 'dev-increment',
        name: 'DevIncrement',
        component: () => import('@/views/deploy/devops/dev-increment.vue'),
        meta: {
          title: '测试环境',
          authCode: 'deploy-devops-dev'
        }
      },
      {
        path: 'pre-increment',
        name: 'PreIncrement',
        component: () => import('@/views/deploy/devops/pre-increment.vue'),
        meta: {
          title: '预生产环境',
          authCode: 'deploy-devops-pre'
        }
      },
      {
        path: 'ios-resign',
        name: 'iOSResign',
        component: () => import('@/views/deploy/ios-resign/ios-resign.vue'),
        meta: {
          title: 'iOS重签名',
          authCode: 'deploy-devops-pre'
        }
      }
    ]
  },
  {
    path: 'office-software',
    name: 'OfficeSoftware',
    component: () => import('@/views/static-resource/office-software/office-software.vue'),
    meta: {
      title: '办公软件',
      authCode: 'office-software-view',
      keepAlive: true
    }
  },
  {
    path: 'add-software',
    name: 'AddSoftware',
    component: () => import('@/views/static-resource/office-software/edit-software.vue'),
    meta: {
      title: '新增软件',
      authCode: 'office-software-add'
    }
  },
  {
    path: 'edit-software',
    name: 'EditSoftware',
    component: () => import('@/views/static-resource/office-software/edit-software.vue'),
    meta: {
      title: '编辑软件',
      authCode: 'office-software-edit'
    }
  },
  {
    path: 'view-software',
    name: 'ViewSoftware',
    component: () => import('@/views/static-resource/office-software/view-software.vue'),
    meta: {
      title: '软件详情',
      authCode: 'office-software-view',
      keepAlive: true
    }
  },
  {
    path: 'online-image',
    name: 'OnlineImage',
    component: () => import('@/views/static-resource/online-image/online-image.vue'),
    meta: {
      title: '线上图片',
      authCode: 'online-image-view',
      keepAlive: false
    }
  },
  {
    path: 'add-image',
    name: 'AddImage',
    component: () => import('@/views/static-resource/online-image/add-image.vue'),
    meta: {
      title: '新增图片',
      authCode: 'online-image-add',
      keepAlive: false
    }
  },
  {
    path: 'edit-image',
    name: 'EditImage',
    component: () => import('@/views/static-resource/online-image/add-image.vue'),
    meta: {
      title: '编辑图片',
      authCode: 'online-image-edit',
      keepAlive: false
    }
  },
  {
    path: 'video-demand',
    name: 'VideoDemand',
    component: () => import('@/views/static-resource/video-demand.vue'),
    meta: {
      title: '视频点播',
      authCode: 'video-demand-view',
      keepAlive: true
    }
  },
  {
    path: 'shell-console',
    name: 'ShellConsole',
    component: () => import('@/views/tools/shell-console/shell-console.vue'),
    meta: {
      title: 'Shell 控制台',
      authCode: 'layout-shell-console',
      keepAlive: true
    }
  },
  {
    path: 'sentry-config',
    name: 'SentryConfig',
    component: () => import('@/views/sentry-monitor/sentry-config/sentry-config.vue'),
    meta: {
      title: '哨兵动态配置',
      authCode: 'sentry-config-view',
      keepAlive: false
    }
  },
  {
    path: 'add-sentry-config',
    name: 'AddSentryConfig',
    component: () => import('@/views/sentry-monitor/sentry-config/sentry-config-handle.vue'),
    meta: {
      title: '新增哨兵配置',
      authCode: 'sentry-config-add',
      keepAlive: false
    }
  },
  {
    path: 'edit-sentry-config',
    name: 'EditSentryConfig',
    component: () => import('@/views/sentry-monitor/sentry-config/sentry-config-handle.vue'),
    meta: {
      title: '编辑哨兵配置',
      authCode: 'sentry-config-edit',
      keepAlive: false
    }
  },
  {
    path: 'sentry-ignore-config',
    name: 'SentryIgnoreConfig',
    component: () => import('@/views/sentry-monitor/ignore-rule/ignore-rule.vue'),
    meta: {
      title: '过滤规则',
      authCode: 'ignore-rule-view',
      keepAlive: false
    }
  },
  {
    path: 'static-file',
    name: 'StaticFile',
    component: () => import('@/views/static-resource/static-file/static-file.vue'),
    meta: {
      title: '静态文件',
      authCode: 'online-image-view',
      keepAlive: false
    }
  },
  {
    path: 'upload-static-file',
    name: 'UploadStaticFile',
    component: () => import('@/views/static-resource/static-file/static-file-handler.vue'),
    meta: {
      title: '上传文件',
      authCode: 'online-image-view',
      keepAlive: false
    }
  },
  {
    path: 'update-static-file',
    name: 'UpdateStaticFile',
    component: () => import('@/views/static-resource/static-file/static-file-handler.vue'),
    meta: {
      title: '更新文件',
      authCode: 'online-image-view',
      keepAlive: false
    }
  },
  {
    path: 'config-center',
    name: 'ConfigCenter',
    component: () => import('@/views/config-center/config-center.vue'),
    meta: {
      title: '配置中心',
      authCode: 'config-center-view',
      keepAlive: false
    }
  },
  {
    path: 'extend-page',
    name: 'ExtendPage',
    component: () => import('@/views/extend-page.vue'),
    meta: {
      keepAlive: false,
      noWarpSpace: true
    }
  },
  {
    path: 'ssl-checker',
    name: 'SSLChecker',
    component: () => import('@/views/kanban/ssl-checker/ssl-checker.vue'),
    meta: {
      title: 'SSL证书看板',
      keepAlive: false
    }
  },
  {
    path: 'code-template',
    name: 'CodeTemplate',
    component: () => import('@/views/efficient-office/code-template/code-template.vue'),
    meta: {
      title: '代码模版',
      keepAlive: false,
      authCode: 'search-code-template-list'
    }
  },
  {
    path: 'code-template-handler',
    name: 'CodeTemplateHandler',
    component: () => import('@/views/efficient-office/code-template/code-template.handler.vue'),
    meta: {
      title: '代码模版',
      keepAlive: false
    }
  },
  {
    path: 'bookmark-list',
    name: 'bookmarkList',
    component: () => import('@/views/efficient-office/bookmark-management/bookmark-list.vue'),
    meta: {
      title: '标签列表',
      keepAlive: false,
      authCode: 'bookmark-view'
    }
  },
  {
    path: 'dict-list',
    name: 'dictList',
    component: () => import('@/views/system/dict/dict-list.vue'),
    meta: {
      title: '字典管理',
      keepAlive: false,
      authCode: 'dict-view'
    }
  },
  {
    path: 'fist-of-fury',
    name: 'fistOfFury',
    component: () => import('@/views/efficient-office/fist-of-fury/fist-of-fury.vue'),
    meta: {
      title: '精武门',
      keepAlive: false,
      authCode: ''
    }
  },
  {
    path: 'rd-efficiency-cron',
    name: 'RDEfficiencyCron',
    component: () => import('@/views/rd-efficiency/cron-task.vue'),
    meta: {
      title: '定时任务',
      keepAlive: false,
      authCode: ''
    }
  },
  {
    path: 'task-list',
    name: 'TaskList',
    component: () => import('@/views/efficient-office/task-manage/task-list.vue'),
    meta: {
      title: '任务管理',
      keepAlive: false,
      authCode: 'task-manage-view'
    }
  },
  {
    path: 'multi-agent-llm-config',
    name: 'MultiAgentLLMConfig',
    component: () => import('@/views/multi-agent/llm-config/llm-config-list.vue'),
    meta: {
      title: '模型配置',
      keepAlive: false
    }
  },
  {
    path: 'multi-agent-agents',
    name: 'MultiAgentAgents',
    component: () => import('@/views/multi-agent/agents/agent-list.vue'),
    meta: {
      title: '智能体管理',
      keepAlive: false
    }
  },
  {
    path: 'multi-agent-crews',
    name: 'MultiAgentCrews',
    component: () => import('@/views/multi-agent/crews/crew-list.vue'),
    meta: {
      title: 'Crew团队管理',
      keepAlive: false
    }
  },
  {
    path: 'multi-agent-mounted-projects',
    name: 'MultiAgentMountedProjects',
    component: () => import('@/views/multi-agent/mounted-projects/mounted-projects-list.vue'),
    meta: {
      title: '挂载工程',
      keepAlive: false
    }
  },
  {
    path: 'multi-agent-tasks',
    name: 'MultiAgentTasks',
    component: () => import('@/views/multi-agent/tasks/task-list.vue'),
    meta: {
      title: '任务管理',
      keepAlive: false
    }
  },
  {
    path: 'multi-agent-skills',
    name: 'MultiAgentSkills',
    component: () => import('@/views/multi-agent/skills/skill-list.vue'),
    meta: {
      title: '技能管理',
      keepAlive: false
    }
  },
  {
    path: 'multi-agent-chat',
    name: 'MultiAgentChat',
    component: () => import('@/views/multi-agent/agent-chat/multi-agent-chat.vue'),
    meta: {
      title: '智能体协同对话',
      keepAlive: false
    }
  },
  {
    path: 'multi-agent-scan-cache',
    name: 'MultiAgentScanCache',
    component: () => import('@/views/multi-agent/scan-cache/scan-cache-management.vue'),
    meta: {
      title: '扫描缓存管理',
      keepAlive: false
    }
  }
]
export default routes
